export default "__VITE_ASSET__NCub$DSc__"